import { Route } from 'react-router'

import { BillingPage } from './Details/BillingPage'
import { PlansPage } from './Plans/PlansPage'
import { PurchasePage } from './Purchase/PurchasePage'

export const Billing = () => {
  return (
    <>
      <Route path="/manage/settings/billing" exact>
        <BillingPage />
      </Route>
      <Route path="/manage/settings/billing/purchase" exact>
        <PurchasePage />
      </Route>
      <Route path="/manage/settings/billing/plans" exact>
        <PlansPage />
      </Route>
    </>
  )
}
